import React, { Component } from 'react';
import { Form, DatePicker } from 'antd';
import moment, { isMoment } from 'moment';

export class RentalPeriod extends Component {

  render() {
    const { unlimitEdit, contractParam } = this.props;
    return <>
      <div className="title-contract">
        5. Thời gian thuê*
        </div>
      <Form.Item
        name="from_datetime"
        label="+ Bắt đầu từ::"
        dependencies={['to_datetime']}
        hasFeedback
        rules={[
          ({ getFieldValue }) => ({
            validator(rule, value) {
              if (!isMoment(value)) {
                return Promise.reject('Hãy chọn thời gian bắt đầu');
              }
              // if (value.unix() < moment().unix()){
              //   return Promise.reject('Thời gian bắt đầu lớn hơn hiện tại');
              // }

              if (getFieldValue('to_datetime')) {
                if (getFieldValue('to_datetime').unix() > value.unix()) {
                  return Promise.resolve();
                } else {
                  return Promise.reject('Thời gian kết thúc phải lớn hơn thời gian bắt đầu');
                }
              } else {
                return Promise.resolve();
              }
            },
          }),
        ]
        }
      >
        <DatePicker
          // inputReadOnly
          dropdownClassName="date-picker-dropdown-top"
          disabled={!unlimitEdit || contractParam && contractParam.status === 3}
          getPopupContainer={node => {
            if (node) {
              return node.parentNode;
            }
            return document.body;
          }} format='DD/MM/YYYY' style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item
        name="to_datetime"
        label="+ Đến::"
        hasFeedback
        dependencies={['from_datetime']}
        rules={[
          ({ getFieldValue }) => ({
            validator(rule, value) {
              if(contractParam){
                if (moment(contractParam.to_datetime).format('DD/MM/YYYY') === value.format('DD/MM/YYYY')){
                  return Promise.resolve();
                }
              }
              if (!isMoment(value)) {
                return Promise.reject('Hãy chọn thời gian kết thúc');
              }
              if (value.unix() < moment().startOf('day').unix()) {
                return Promise.reject('Thời gian kết thúc phải lớn hơn hiện tại');
              }
              if (getFieldValue('from_datetime')) {
                if (getFieldValue('from_datetime').startOf('day').unix() < value.startOf('day').unix()) {
                  return Promise.resolve();
                } else {
                  return Promise.reject('Thời gian kết thúc phải lớn hơn thời gian bắt đầu');
                }
              } else {
                return Promise.resolve();
              }
            },
          }),
        ]
        }
      >
        <DatePicker
          // inputReadOnly
          dropdownClassName="date-picker-dropdown-top"
          disabled={!unlimitEdit}
          getPopupContainer={node => {
          if (node) {
            return node.parentNode;
          }
          return document.body;
        }} format='DD/MM/YYYY' style={{ width: '100%' }} />
      </Form.Item>
    </>
  }
}